module.exports = __webpack_public_path__ + "static/media/call10.cd01a6a7.gif";